var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 35,
    viewBox: "0 0 53 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.808 0H2.692A2.7 2.7 0 0 0 0 2.692v29.616A2.7 2.7 0 0 0 2.692 35h47.116a2.7 2.7 0 0 0 2.692-2.692V2.692A2.7 2.7 0 0 0 49.808 0zm-1.01 2.02-21 15.75c-.377.287-.956.466-1.548.464-.592.002-1.171-.177-1.549-.465L3.703 2.02h45.094zM37.58 18.807l11.443 14.135c.011.014.025.025.038.038H3.439c.012-.014.027-.024.038-.038L14.92 18.808a1.01 1.01 0 0 0-1.57-1.27L2.02 31.534V3.281L23.49 19.384c.807.602 1.79.866 2.76.869.969-.002 1.952-.267 2.76-.869L50.48 3.281v28.253L39.15 17.538a1.01 1.01 0 1 0-1.57 1.27z",
    fill: "#AAB1CC",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.503c33012d0d1b794a70dd0506df2e37.svg";
export { ForwardRef as ReactComponent };